export enum RestaurantSectionType {
  FOOD = 'FOOD',
  DRINKS = 'DRINKS',
  NON_FOOD = 'NON_FOOD',
}

export const getRestaurantSectionTypeDisplayName = (type: RestaurantSectionType): string => {
  switch (type) {
    case RestaurantSectionType.FOOD:
      return "Food";
    case RestaurantSectionType.DRINKS:
      return "Drinks";
    case RestaurantSectionType.NON_FOOD:
      return "Non-Food";
    default:
      return type;
  }
};

export const getAvailableRestaurantSectionTypes = (): RestaurantSectionType[] => {
  return Object.values(RestaurantSectionType);
};

